:host {
  display: block;
}

.cta-area {
  display: block;
}

@media screen and (max-width: 979px) {
  .cta-area {
    padding: 24px 16px;
    background: #fafafa;
    border: 1px solid #e7e6e6;
    margin-bottom: 24px;
  }
}

@media screen and (min-width: 980px) {
  .cta-area {
    padding: 24px 0;
  }
}

.cta-area__button {
  width: 100%;
}

@media screen and (min-width: 980px) {
  .cta-area-pbs {
    border-bottom: none;
  }
}

@media screen and (min-width: 980px) {
  .cta-area--prioritized-buy-now-button {
    border-bottom: none;
  }
}

.cta-area__container {
  display: flex;
  flex-direction: column;
}

@media screen and (min-width: 980px) {
  .cta-area__container-block:not(.circular-economy-container) {
    max-width: 465px;
  }
}

@media screen and (min-width: 980px) {
  .cta-area__container-skeleton {
    min-height: 160px;
    max-width: 320px;
  }
}

@media screen and (min-width: 980px) {
  .cta-area__row {
    margin-top: 20px;
  }
}

.cta-area__row.cta-area__row--with-tag {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  max-width: 382px;
}

@media screen and (max-width: 979px) {
  .cta-area__row {
    margin-top: 16px;
  }
}

.cta-area__row:first-child {
  margin-top: 0;
}

slot[name=discounted-price]:first-child + .cta-area__row {
  margin-top: 0;
}

@media screen and (min-width: 980px) {
  .cta-area--has-slotted-discounted-price .cta-area__row:first-child {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 979px) {
  .cta-area--has-slotted-discounted-price .cta-area__row:first-child {
    margin-bottom: 16px;
  }
}

@media screen and (min-width: 980px) {
  .cta-area--has-slotted-discounted-price slot[name=discounted-price]:first-child + .cta-area__row {
    margin-top: 20px;
  }
}

@media screen and (max-width: 979px) {
  .cta-area--has-slotted-discounted-price slot[name=discounted-price]:first-child + .cta-area__row {
    margin-top: 16px;
  }
}

@media screen and (max-width: 979px) {
  .circular-economy-container {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 979px) {
  .cta-area__price-container {
    margin-left: auto;
    margin-right: auto;
  }
}

.cta-area__skeleton {
  --se-divider: #e6e6e6;
  --se-background-standard: #ffffff;
}

@media screen and (min-width: 980px) {
  .cta-area__skeleton + .cta-area__skeleton {
    margin-top: 8px;
  }
}

@media screen and (max-width: 979px) {
  .cta-area__row + .cta-area__quick-actions-container, .cta-area--has-slotted-discounted-price slot[name=discounted-price] + .cta-area__quick-actions-container {
    margin-top: 24px;
    padding-top: 4px;
    border-top: 1px solid #e7e6e6;
  }

  .cta-area__quick-actions-container:first-child, .cta-area:not(.cta-area--has-slotted-discounted-price) .cta-area__quick-actions-container {
    margin-top: -16px;
  }

  .cta-area:not(.cta-area--has-slotted-discounted-price) .cta-area__row + .cta-area__quick-actions-container {
    margin-top: 24px;
  }
}

@media screen and (min-width: 980px) {
  .cta-area__quick-actions-container {
    display: none;
  }
}

@media screen and (max-width: 979px) {
  .cta-area__quick-actions {
    display: block;
    text-align: center;
    margin-top: 5px;
  }
}

@media screen and (min-width: 980px) {
  .cta-area__quick-actions {
    display: none;
  }
}

.stock-quantity-info {
  display: flex;
  gap: 8px;
}

@media screen and (max-width: 979px) {
  .stock-quantity-info {
    margin: auto;
  }
}

.stock-quantity-info__icon-container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  font-size: 1rem;
  color: #007626;
}

.stock-quantity-info__label {
  font-size: 1rem;
  line-height: 1.5rem;
}